module.exports = __webpack_public_path__ + "static/media/recent-one.424affae.png";